import React, { useEffect, useRef } from "react";
import MonacoEditor, { Editor, loader } from "@monaco-editor/react";
loader.config({
  paths: { vs: window.location.origin + "/monaco-editor/min/vs" },
});

// Helper: Extract all <div id="..."> lines
function findDivIdsByLine(content = "") {
  const lines = content.split("\n");
  const divIdLines = [];
  const regex = /<div\s+[^>]*id=["']([\w:-]+)["'][^>]*>/i;
  lines.forEach((line, idx) => {
    const match = line.match(regex);
    if (match) {
      divIdLines.push({
        lineNumber: idx + 1,
        id: match[1],
      });
    }
  });
  //console.log(divIdLines);
  return divIdLines;
}
export default function MyEditor({
  lernmodul,
  isDark,
  onLernmodulChange,
  dragOver,
  onDragOver,
  onDragLeave,
  onDrop,
  handleEditorDidMount,
  fontSize,
  onVisibleDivIdChange,
}) {
  const editorRef = useRef(null);
  const divIdLinesRef = useRef([]);
  // Update div id lines if lernmodul changes
  useEffect(() => {
    divIdLinesRef.current = findDivIdsByLine(lernmodul ?? "");
    // Optionally, call with null if no visible id (for reactivity)
    /*if (onVisibleDivIdChange) {
      onVisibleDivIdChange(null);
    }*/
  }, [lernmodul, onVisibleDivIdChange]);

  // Setup scroll event
  function handleEditorMount(editor, monaco) {
    editorRef.current = editor;

    // Let parent component mount hook run, if you need it
    if (handleEditorDidMount) handleEditorDidMount(editor, monaco);

    // Remove previous scroll handler if any
    if (editor._myScrollListener) {
      editor._myScrollListener.dispose();
    }
    if (editor._myMouseListener) {
      editor._myMouseListener.dispose();
    }

    const onScroll = () => {
      // Get top visible line
      const visibleRanges = editor.getVisibleRanges();

      if (!visibleRanges || !visibleRanges[0]) return;
      const visibleTopLine = visibleRanges[0].startLineNumber;

      // Find nearest div id at or before top visible line
      let currentId = null;
      for (let i = 0; i < divIdLinesRef.current.length; i++) {
        if (divIdLinesRef.current[i].lineNumber <= visibleTopLine) {
          currentId = divIdLinesRef.current[i].id;
        } else {
          break;
        }
      }

      // Demo: log or call a callback

      if (onVisibleDivIdChange) {
        onVisibleDivIdChange(currentId);
      }
    };
    // --- Mouse handler (mousedown or click) ---
    const handleMouseEvent = (e) => {
      if (!e.target || !e.target.position) return;
      const { lineNumber } = e.target.position;
      let currentId = null;
      for (let i = 0; i < divIdLinesRef.current.length; i++) {
        if (divIdLinesRef.current[i].lineNumber <= lineNumber) {
          currentId = divIdLinesRef.current[i].id;
        } else {
          break;
        }
      }
      console.log("Mouse on line, div id:", currentId);
      if (onVisibleDivIdChange) onVisibleDivIdChange(currentId);
    };
    // Listen and store disposable for later cleanup
    editor._myScrollListener = editor.onDidScrollChange(onScroll);
    editor._myMouseListener = editor.onMouseDown(handleMouseEvent);

    // Optionally: also call once on mount
    setTimeout(onScroll, 0);
  }

  useEffect(() => {
    // Clean up scroll event on unmount
    return () => {
      if (editorRef.current?._myScrollListener) {
        editorRef.current._myScrollListener.dispose();
        editorRef.current._myScrollListener = null;
      }
      if (editorRef.current?._myMouseListener) {
        editorRef.current._myMouseListener.dispose();
        editorRef.current._myMouseListener = null;
      }
    };
  }, []);
  return (
    <>
      <div
        style={{
          borderTop: dragOver ? "1px solid #10b981" : "1px solid #ddd",
          background: dragOver ? "#e7fce9" : "white",
          transition: "all 0.16s",
          width: "100%",
          height: "100%",
          minHeight: 0,
          boxSizing: "border-box",
        }}
        className="w-full h-full"
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
      >
        <MonacoEditor
          height="100%"
          width="100%"
          language="javascript"
          theme={isDark ? "vs-dark" : "vs-light"}
          value={lernmodul}
          onChange={onLernmodulChange}
          // onMount={handleEditorDidMount}
          onMount={handleEditorMount}
          options={{
            fontFamily: "monospace",
            fontSize: fontSize,
            padding: { top: 12 },
            tabSize: 2,
            minimap: { enabled: true },
            placeholder: "Drag and drop your ZIP file (< 50 MB) here! ",
            lineNumbers: lernmodul.length === 0 ? "off" : "on",
            wordWrap: "on",
            renderLineHighlightOnlyWhenFocus: "true",
            //Intellisense
            // ...your other options
            //quickSuggestions: false,
            //suggestOnTriggerCharacters: false,
            //wordBasedSuggestions: false,
            //suggest: { showWords: false },
            //parameterHints: { enabled: false },
            //tabCompletion: "off",
            //hover: { enabled: false }, // Optional: disables hover tooltips too
            // If you use "lightbulb" feature
            //lightbulb: { enabled: false },
            //
          }}

          // Es gibt kein placeholder in Monaco -> optional eigenes Overlay-Handling
        />
        {/* Falls du ein Placeholder willst, braucht es eine eigene Lösung */}
      </div>
    </>
  );
}
